'use client';

import { ComponentProps, PropsWithChildren, useContext } from 'react';
import { AppConfigContext } from '@/features/app-providers/app-config-provider';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { LocalizedString } from '@/shared/model/Language';
import { Layout } from '@/shared/ui/layout';
import { hasSocialLinks } from './has-social-links';

type LayoutProps = ComponentProps<typeof Layout>;

export const FooterSocialSection = ({ children, ...props }: PropsWithChildren<LayoutProps>) => {
    const { socialLinks } = useContext(AppConfigContext);
    const getLocalizedValue = useGetLocalizedValue();

    if (
        !hasSocialLinks(socialLinks, (raw) => (raw ? getLocalizedValue(raw as LocalizedString) : undefined))
    ) {
        return null;
    }

    return (
        <Layout data-testid="footer-social-section" {...props}>
            {children}
        </Layout>
    );
};
